import { render, staticRenderFns } from "./how-to-download-instagram-stories-before-they-disappear.vue?vue&type=template&id=6f5ce191"
import script from "./how-to-download-instagram-stories-before-they-disappear.vue?vue&type=script&lang=js"
export * from "./how-to-download-instagram-stories-before-they-disappear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports